import { RoleConditional, RoleConditionalProps } from './RoleConditional';

export const OrganizerConditional = (props: RoleConditionalProps) =>
  RoleConditional(props, ['ORGANIZER', 'MANAGER']);

export default OrganizerConditional;
